module.exports = new __parcel__URL__("lwn-fr.0fef77da.svg").toString();